import Route from '@ember/routing/route';
import type { ModelFrom } from 'frontend-login/utils/routes';

export type Model = ModelFrom<ChangeEmailRoute>;

type Params = {
  code: string;
};

export default class ChangeEmailRoute extends Route {
  model(params: Params): {
    changeEmailCode: string;
  } {
    return {
      changeEmailCode: params.code,
    };
  }
}
